import { SERVICE_NAME, SystemServiceProvider } from './system.service'
import { SYSTEM_TARGET_SERVICE_NAME, SystemTargetServiceProvider } from './system.target.service'
import { SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListServiceProvider } from './system.context-list.service'
import { SYSTEM_INTERNATIONALIZATION_SERVICE_NAME, SystemInternationalizationServiceProvider } from './system.internationalization.service'

export const SYSTEM_SERVICES_MODULE_NAME = 'simax.services.system'

const module = angular.module(SYSTEM_SERVICES_MODULE_NAME, [])

module.provider(SERVICE_NAME, ['$stateProvider', SystemServiceProvider])
module.provider(SYSTEM_TARGET_SERVICE_NAME, SystemTargetServiceProvider)
module.provider(SYSTEM_CONTEXT_LIST_SERVICE_NAME, SystemContextListServiceProvider)
module.provider(SYSTEM_INTERNATIONALIZATION_SERVICE_NAME, SystemInternationalizationServiceProvider)
